/*
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   AddressBackNavButton.tsx
 */

import type { LinkProps } from '@chakra-ui/react'
import { BackNavButton } from '@zcode-ui/web-zumper-features'
import { toCityUrl } from '@zcode/nr-utils'
import type { State } from '@zcode/state-type'
import { useSelector } from 'react-redux'
import { useAddressPageContext } from '../../AddressPageContext'

const selectCityUrl = (state: State) => {
  return (
    state.permanentAddress.city?.listUrl ||
    (state.permanentAddress.address?.cityState &&
      toCityUrl({ cityState: state.permanentAddress.address?.cityState })) ||
    state.detail.entity.data?.cityUrl ||
    ''
  )
}

const selectCity = (state: State) => {
  return state.permanentAddress.city?.name ?? ''
}

export const AddressBackNavButton = (props: Omit<LinkProps, 'onClick'>) => {
  const city = useSelector(selectCity)
  const cityUrl = useSelector(selectCityUrl)
  const {
    getRootRelativeUrlFromFiltersAndLocation,
    handleBackBtnClick,
    keepBetaParam,
    preloadRoutes,
    Routes,
  } = useAddressPageContext()

  return (
    <BackNavButton
      Routes={Routes}
      city={city}
      cityUrl={cityUrl}
      getRootRelativeUrlFromFiltersAndLocation={getRootRelativeUrlFromFiltersAndLocation}
      handleBackBtnClick={handleBackBtnClick}
      keepBetaParam={keepBetaParam}
      preloadRoutes={preloadRoutes}
      {...props}
    />
  )
}
